import { graphql } from 'react-relay';
export const EditorTypeAndVersionPropertyQuery = graphql`
	query EditorTypeAndVersionPropertyQuery($contentId: ID) {
		content(id: $contentId, status: ["current", "draft"]) {
			nodes {
				id
				type
				editor: properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
			}
		}
	}
`;
